import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Form, SubmissionHandler } from "vee-validate";
import { ref, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationObserver',
  props: {
  tag: {
    type: String,
    default: "div"
  },
  initialValues: {
    type: Object,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    default: () => ({} as PropType<Record<string, any>>)
  }
},
  setup(__props, { expose: __expose }) {

// NOTE: このコンポーネントは vee-validate v3 で書かれたコードをカバーするために作成したものです。
// 新規でフォームを用意する場合は、原則 ValidationForm (plugins 内で定義した vee-validate のコンポーネント) を利用してください。


const form = ref<typeof Form | null>(null);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reset = (values?: any) => form.value!.resetForm(values);

const validate = () => form.value!.validate();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setValues = (values?: any) => form.value!.setValues(values);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setErrors = (values?: any) => form.value!.setErrors(values);

const submit = async (func: Function) => {
  const { valid } = await validate();
  if (!valid) {
    return;
  }
  // Form の handleSubmit を使うと引数が追加されるため、ここで引数無しで呼び出す
  return func();
};

__expose({
  reset,
  validate,
  setValues,
  setErrors
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    ref_key: "form",
    ref: form,
    as: __props.tag,
    initialValues: __props.initialValues
  }, {
    default: _withCtx(({ meta, resetForm, setErrors }) => [
      _renderSlot(_ctx.$slots, "default", {
        handleSubmit: submit,
        valid: meta.valid,
        resetForm: resetForm,
        setErrors: setErrors
      })
    ]),
    _: 3
  }, 8, ["as", "initialValues"]))
}
}

})